import ReturnsNullOn404 from "common/http/returnsNullOn404";
import ThrowsValidationError from "common/http/throwsValidationError";
import Permission from "domain/permission";
import Role from "./role";
import UserRoleAssignment from "./userRoleAssignment";
import HttpService from "common/http/httpService";


class RoleService extends HttpService {

    async listRoles(): Promise<Role[]> {
        const response = await this.getClient().get<Role[]>('/settings/v1/roles');
        return response.data;
    }

    @ReturnsNullOn404()
    async getRole(id: number): Promise<Role> {
        const response = await this.getClient().get<Role>(`/settings/v1/roles/${id}`);
        return response.data;
    }

    @ThrowsValidationError()
    async createRole(role: Role): Promise<Role> {
        const response = await this.getClient().post<Role>('/settings/v1/roles', role);
        return response.data;
    }

    @ThrowsValidationError()
    async updateRole(id: number, role: Role): Promise<void> {
         await this.getClient().put(`/settings/v1/roles/${id}`, role);
    }

    @ThrowsValidationError()
    async deleteRole(id: number): Promise<void> {
        await this.getClient().delete(`/settings/v1/roles/${id}`);
    }

    async listUsersInRole(roleId?: number, merchantId?: string): Promise<UserRoleAssignment[]> {
        const response = await this.getClient().get(`/settings/v1/roles/${roleId}/users`, {
            params: {
                merchantId
            }
        });
        return response.data;
    }

    async listUserRolesForMerchant(merchantId: string): Promise<UserRoleAssignment[]> {
        const response = await this.getClient().get(`/settings/v1/merchants/${merchantId}/user-roles`);
        return response.data;
    }
    
    @ThrowsValidationError()
    async addUserToRole(roleId: number, userId: string, merchantId: string): Promise<any> {
        await this.getClient().post(`/settings/v1/roles/${roleId}/assign`, {
            userId,
            merchantId
        });
    }
    
    @ThrowsValidationError()
    async removeUserFromRole(roleId: number, userId: string, merchantId: string): Promise<any> {
        await this.getClient().post(`/settings/v1/roles/${roleId}/unassign`, {
            userId,
            merchantId
        });
    }

    async listPermissions(): Promise<Permission[]> {
        const response = await this.getClient().get<Permission[]>('/settings/v1/permissions');
        return response.data;
    }
}

const roleService = new RoleService();

export default roleService;